import { FC } from 'react';
import UserList from './UserList';
import UseUserList from './UseUserList';

const UserListContainer: FC = () => {
  return <UserList {...UseUserList()} />;
};

export default UserListContainer;
